import type { PlanKey } from "../components/account/PlanBadge"

const PLAN_ORDER: Record<PlanKey, number> = { free: 0, pro: 1, business: 2 }

// account の plan が required 以上かどうか（バックエンドの Plan.at_least? と同じ順序比較）
export const isAtLeastPlan = (plan: PlanKey, required: PlanKey): boolean =>
  PLAN_ORDER[plan] >= PLAN_ORDER[required]
